<div class="row mx-0 sg-RTA-container">
    <form [formGroup]="RTAForm" class="w-100 row mx-0">
        <div class="sg-documents-container ml-3 sg-header-section w-100">
            <div class="row mx-0 margin-top-bottom mt-3">
                <div class="col-6 cws-form-header">
                    <h4 class="sg-page-title"> RTA Form</h4>
                </div>
            </div>
            <div class="cws-back-button ml-3 cursor">
                <div class="row mx-0"><a class="underline" (click)="onClickBackOrClose()">Back</a></div>
            </div> 
        </div>
        <div class="sg-body-section w-100">
            <mat-drawer-container class="sg-main cws-form-container sg-RTA">
            <div class="cws-width pr-4 pl-2">
                <div class="row mx-0 mb-3 p-2 w-100 sg-edit-info border rounded" *ngIf="isRTAReadOnly">
                    <span class="material-icons-outlined pr-2 sg-supplier-management-info">info</span> 
                    <span class="pt-1"> This form is not editable at the moment. Contact Solar if modification are required</span>
                </div> 
                <!-- <div class="row mx-0 flex-column"> -->
                    <div class="mat-dialog-title mb-0 border-bottom  cws-header">General RTA Information</div>
                    <div class="row pl-3 pr-3">
                        <div class="col-3 p-0">
            
                            <div class="sg-form-field-label pt-3 pb-1">
                                RTA Number
                            </div>
                            <div>
                                {{this.getEditRTAInfo ? this.generalRTAInformation.rtaNumber : '-'}}
                            </div>
                            <div class="sg-form-field-label pt-3 pb-1">
                                RTA Status
                            </div>
                            <div>
                                {{this.getEditRTAInfo ? this.generalRTAInformation.rtaStatus : '-'}}
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="sg-form-field-label pt-3 pb-1">
                                RTA Revision Number
                            </div>
                            <div>
                                {{this.getEditRTAInfo ? this.generalRTAInformation.rtaRevison : '-'}}
                            </div>
                            <div class="sg-form-field-label pt-3 pb-1">
                                Supplier Reference #
                            </div>
                            <div>
                                <mat-form-field class="w-100 sg-validation" appearance="outline">
                                    <input matInput formControlName="supplierReference"/>
                                    <mat-error *ngIf="RTAForm.controls.supplierReference.errors?.pattern ||
                                    RTAForm.controls.supplierReference.errors?.hasBackSlash">
                                        The characters \ / * ? " < > | are not allowed.
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="sg-form-field-label pt-3 pb-1">
                                Created By
                            </div>
                            <div>
                                {{this.getEditRTAInfo ? this.generalRTAInformation.submittedBy : '-'}}
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="sg-form-field-label pt-3 pb-1">
                                Created On
                            </div>
                            <div>
                                {{this.getEditRTAInfo ? this.generalRTAInformation.submittedDate : '-'}}
                            </div>
                        </div>
                    </div>
                <!-- </div> -->
                <div class="row mx-0 flex-column">
                <ng-container formGroupName="rtaRequestDetails">
                    <div class="mat-dialog-title mb-0 border-bottom  cws-header">Section 1A - RTA Request Details </div>
                    <div class="row px-3 pt-3">
                        <div class="col-6 pl-0">
                            <label class="sg-form-field-label  d-block font-weight-normal w-100">
                                Supplier / CAM Name <span
                                    class="sg-form-field-required-marker ml-1">*</span>
                            </label>
                            <mat-form-field class="w-100 sg-validation" appearance="outline">
                                <mat-select formControlName="supplierOrCamName" class="sg-select-sup">
                                    <mat-option *ngFor="let item of supplierResults " [value]="item" [selected]='true'>
                                        {{item.supplierName}} <span class="sg-supplier-code">{{item.organizationCode}}</span>   
                                    </mat-option>                        
                                </mat-select>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.supplierOrCamName').hasError('required')">
                                    This is required Field
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-3">
                            <label class="sg-form-field-label  d-block font-weight-normal w-100">
                                Phone <span
                                    class="sg-form-field-required-marker ml-1">*</span>
                            </label>
                            <mat-form-field class="w-100 sg-validation" appearance="outline">
                                <input matInput formControlName="phone" phoneMask />
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.phone').hasError('pattern') ||
                                RTAForm.get('rtaRequestDetails.phone').hasError('hasBackSlash')">
                                    The characters \ / * ? " < > | are not allowed.
                                </mat-error>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.phone').hasError('required')">
                                    This is required Field
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-3">
                            <label class="sg-form-field-label  d-block font-weight-normal w-100">
                                Email <span
                                    class="sg-form-field-required-marker ml-1">*</span>
                            </label>
                            <mat-form-field class="w-100 sg-validation" appearance="outline">
                                <input matInput  formControlName="email" />
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.email').hasError('pattern') ||
                                RTAForm.get('rtaRequestDetails.email').hasError('hasBackSlash')">
                                    The characters \ / * ? " < > | are not allowed.
                                </mat-error>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.email').hasError('required')">
                                    This is required Field
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row px-3 pt-3">
                        <div class="col-3 pl-0">
                            <label class="sg-form-field-label  d-block font-weight-normal w-100">
                                Solar Purchase Order #
                            </label>
                            <mat-form-field class="w-100 sg-validation" appearance="outline">
                                <input matInput formControlName="solarPurchaseOrder" />
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.solarPurchaseOrder').hasError('pattern') ||
                                RTAForm.get('rtaRequestDetails.solarPurchaseOrder').hasError('hasBackSlash')">
                                    The characters \ / * ? " < > | are not allowed.
                                </mat-error>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.solarPurchaseOrder').hasError('required')">
                                    This is required Field
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-3">
                            <label class="sg-form-field-label  d-block font-weight-normal w-100">
                                Solar Production Order #
                            </label>
                            <mat-form-field class="w-100 sg-validation" appearance="outline">
                                <input matInput formControlName="solarProductionOrder" />
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.solarProductionOrder').hasError('pattern') ||
                                RTAForm.get('rtaRequestDetails.solarProductionOrder').hasError('hasBackSlash')">
                                    The characters \ / * ? " < > | are not allowed.
                                </mat-error>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.solarProductionOrder').hasError('required')">
                                    This is required Field
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-3">
                            <label class="sg-form-field-label  d-block font-weight-normal w-100">
                                Operation #
                            </label>
                            <mat-form-field class="w-100 sg-validation" appearance="outline">
                                <input matInput  formControlName="operation" />
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.operation').hasError('pattern') ||
                                RTAForm.get('rtaRequestDetails.operation').hasError('hasBackSlash')">
                                    The characters \ / * ? " < > | are not allowed.
                                </mat-error>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.operation').hasError('required')">
                                    This is required Field
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row px-3 pt-3">
                        <div class="col-6 pl-0">
                            <label class="sg-form-field-label pl-0">
                                Is Nonconforming Condition a Critical to Quality (CTQ) characteristic? <span
                                class="sg-form-field-required-marker ml-1">*</span>
                                <span class="material-icons-outlined sg-supplier-management-info"
                                     matTooltip="Select 'Yes', if the print is identified with a CTQ mark">help
                                </span>
                            </label>
                            <mat-form-field class="w-100 sg-validation" appearance="outline">
                                <mat-select formControlName="isNonconformingConditionCtq"  class="sg-select-sup">
                                    <mat-option value="Yes">Yes</mat-option>
                                    <mat-option value="No">No</mat-option>                           
                                </mat-select>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.isNonconformingConditionCtq').hasError('required')">
                                    This is required Field
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <label class="sg-form-field-label pl-0">
                                Cause of Nonconformance <span
                                class="sg-form-field-required-marker ml-1">*</span>
                            </label>
                            <mat-form-field class="w-100 sg-validation" appearance="outline">
                                <textarea matInput formControlName="causeOfNonconformance" rows="3" maxlength="500"></textarea>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.causeOfNonconformance').hasError('pattern') ||
                                RTAForm.get('rtaRequestDetails.causeOfNonconformance').hasError('hasBackSlash')">
                                    The characters \ / * ? " < > | are not allowed.
                                </mat-error>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.causeOfNonconformance').hasError('required')">
                                    This is required Field
                                </mat-error>
                            </mat-form-field>
        
                        </div>
                    </div>
                    <div class="row px-3 pt-3">
                        <div class="col-6 pl-0">
                            <label class="sg-form-field-label pl-0">
                                Proposed Correction <span
                                class="sg-form-field-required-marker ml-1">*</span>
                            </label>
                            <mat-form-field class="w-100 sg-validation" appearance="outline">
                                <textarea formControlName="proposedCorrection" matInput rows="3" maxlength="500"></textarea>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.proposedCorrection').hasError('pattern') ||
                                RTAForm.get('rtaRequestDetails.proposedCorrection').hasError('hasBackSlash')">
                                    The characters \ / * ? " < > | are not allowed.
                                </mat-error>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.proposedCorrection').hasError('required')">
                                    This is required Field
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <label class="sg-form-field-label pl-0">
                                Comments / Previous Submittals / First Parts / Suggested Repair Plan <span
                                class="sg-form-field-required-marker ml-1">*</span>
                            </label>
                            <mat-form-field class="w-100 sg-validation" appearance="outline">
                                <textarea formControlName="commentsOrSrp" matInput rows="3" maxlength="500"></textarea>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.commentsOrSrp').hasError('pattern') ||
                                RTAForm.get('rtaRequestDetails.commentsOrSrp').hasError('hasBackSlash')">
                                    The characters \ / * ? " < > | are not allowed.
                                </mat-error>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.commentsOrSrp').hasError('required')">
                                    This is required Field
                                </mat-error>
                            </mat-form-field>
        
                        </div>
                    </div>
                    <div #scrollToProposed class="mt-3 cws-header">Proposed Duration (choose one or both) </div>
                    <div  class="row mx-2 mt-3 sg-current border rounded w-30" 
                    *ngIf="isProposedDurationValid">
                        <div class="col-12">
                            <div class="row p-2 "><span 
                                    class="material-icons-outlined pr-2 sg-supplier-management-info pt-1 sg-info">info</span>
                                    <span class="pt-1"> At least one Proposed Duration must be Selected</span>
                            </div>
                        </div>
                    </div>
                    <div class="row px-3 pt-2">
                        <div class="col-3 pl-0 sg-col-sm-3">
                            <label class="sg-form-field-label pl-0">
                                Quantity of Nonconforming Parts
                            </label>
                            <mat-form-field class="w-100 sg-validation" appearance="outline">
                                <input matInput formControlName="quantityOfNonconformingParts" (keydown)="onKeyDown($event)"/>
                                <!-- <mat-error *ngIf="RTAForm.get('rtaRequestDetails.quantityOfNonconformingParts').hasError('pattern')">
                                    Integers are allowed only.
                                </mat-error> -->
                            </mat-form-field>
                        </div>
                        <div class="col-5 pl-0 sg-col-md-5">
                            <label class="sg-form-field-label pl-0">
                                Date
                            </label>
                            <div class="row pl-3 pr-0">
                                <div class="col-6 px-0">
                                    <span class="mr-2">From</span>
                                    <mat-form-field appearance="outline" class="w-75">
                                        <input matInput  [matDatepicker]="from" formControlName="fromDate">
                                        <mat-datepicker-toggle matSuffix [for]="from"></mat-datepicker-toggle>
                                        <mat-datepicker #from></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="col-6 pr-0 pl-2">
                                    <span class="mr-2">To</span>
                                    <mat-form-field appearance="outline" class="w-75">
                                        <input matInput  [matDatepicker]="to" formControlName="toDate">
                                        <mat-datepicker-toggle matSuffix [for]="to"></mat-datepicker-toggle>
                                        <mat-datepicker #to></mat-datepicker>
                                        <mat-error *ngIf="RTAForm.get('rtaRequestDetails.toDate').hasError('dateRangeError')">
                                            From date should not exceed To date.
                                        </mat-error>
                                    </mat-form-field>   
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </ng-container>
                <div  class="mat-dialog-title mb-0 border-bottom  cws-header">Section 1B - Current Condition </div>
                <div  class="row mx-2 mt-3 sg-current border rounded w-30" *ngIf="currentCondition.controls.length == 0">
                    <div class="col-12">
                        <div class="row p-2"><span 
                                class="material-icons-outlined pr-2 sg-supplier-management-info pt-1 sg-info">info</span>
                                <span class="pt-1"> At least one Current Condition must be added</span></div>
                    </div>
                </div>
                <ng-container  formArrayName="currentCondition">    
                <div  class="row px-3 my-3 rta-current-condition"
                    *ngFor="let currentControls of currentCondition.controls; let i = index" [formGroupName]="i" [attr.id]="'scrollSection-' + i">
                    <!-- <ng-container [formGroupName]="i"> -->
                        
                        <div class="px-1 pt-2">
                            <div class="letter-container">{{i+1}}</div>
                        </div>
                        <div class="col-9 pt-2 pr-0">
                            <div class="row px-3 mx-0">
                                <div class="col-4 pl-0">
                                    <label class="sg-form-field-label  d-block font-weight-normal w-100">
                                        Drawing/Spec.Requirement <span
                                            class="sg-form-field-required-marker ml-1">*</span>
                                    </label>
                                    <mat-form-field class="w-100 sg-validation" appearance="outline">
                                        <input matInput formControlName="drawingOrSpecRequirement" />
                                        <mat-error *ngIf="RTAForm.get('currentCondition.' + i + '.drawingOrSpecRequirement').hasError('required')">
                                            This is required Field
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-4 pl-0">
                                    <label class="sg-form-field-label  d-block font-weight-normal w-100">
                                        Blue Print Zone/Spec. Section <span
                                            class="sg-form-field-required-marker ml-1">*</span>
                                    </label>
                                    <mat-form-field class="w-100 sg-validation" appearance="outline">
                                        <input matInput formControlName="bluePrintZoneSection" />
                                        <mat-error *ngIf="RTAForm.get('currentCondition.' + i + '.bluePrintZoneSection').hasError('required')">
                                            This is required Field
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-4 pl-0">
                                    <label class="sg-form-field-label  d-flex font-weight-normal w-100">
                                        Is CTQ? <span
                                            class="sg-form-field-required-marker ml-1">*</span>
                                            <span class="material-icons-outlined pl-2 sg-supplier-management-info"
                                            matTooltip="Select 'Yes', if the print is identified with a CTQ mark"
                                            >help</span>
                                    </label>
                                    <mat-form-field class="w-100 sg-validation" appearance="outline">
                                        <mat-select formControlName="isCtq"  class="sg-select-sup">
                                            <mat-option value="Yes">Yes</mat-option>
                                            <mat-option value="No">No</mat-option>                           
                                        </mat-select>
                                        <mat-error *ngIf="RTAForm.get('currentCondition.' + i + '.isCtq').hasError('required')">
                                            This is required Field
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row px-3 mx-0">
                                <div class="col-4 pl-0">
                                    <label class="sg-form-field-label  d-block font-weight-normal w-100">
                                        Actual Condition <span
                                            class="sg-form-field-required-marker ml-1">*</span>
                                    </label>
                                    <mat-form-field class="w-100 sg-validation" appearance="outline">
                                        <input matInput formControlName="actualCondition" />
                                        <mat-error *ngIf="RTAForm.get('currentCondition.' + i + '.actualCondition').hasError('required') ||
                                        RTAForm.get('currentCondition.' + i + '.actualCondition').invalid">
                                            This is required Field
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-4 pl-0">
                                    <label class="sg-form-field-label  d-block font-weight-normal w-100">
                                        Quantity
                                        <span class="sg-form-field-required-marker ml-1" *ngIf="isQauntityRequire">*</span>
                                    </label>
                                    <mat-form-field class="w-100 sg-validation" appearance="outline">
                                        <input matInput formControlName="quantity" (keydown)="onKeyDown($event)" />
                                        <mat-error *ngIf="RTAForm.get('currentCondition.' + i + '.quantity').hasError('required') ||
                                        RTAForm.get('currentCondition.' + i + '.quantity').invalid">
                                            This is required Field
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-4 pl-0">
                                    <label class="sg-form-field-label  d-block font-weight-normal w-100">
                                        Serial Number
                                    </label>
                                    <mat-form-field class="w-100 sg-validation   cws-error-container" appearance="outline">
                                        <input matInput formControlName="serialNumber" />
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row px-3 mx-0 py-2">
                                <div class="col-12 pl-0">
                                    <label class="sg-form-field-label  d-block font-weight-normal w-100">
                                        Additional Comments
                                    </label>
                                    <mat-form-field class="w-100 sg-validation   cws-error-container" appearance="outline">
                                        <textarea formControlName="additionalComments" matInput rows="3" maxlength="500"></textarea>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col-2 pt-2 pr-1 border-left">
                            <div class="row pl-2 mx-0 pb-4">
                                <div class="col-12 px-0">Disposition (Solar) </div>
                                <div class="mt-2 col-12 px-0">
                                    <mat-form-field class="w-100 sg-validation" appearance="none">
                                        <input matInput formControlName="disposition" readonly/>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row pl-2 mx-0 pt-3">
                                <label class="sg-form-field-label col-12 px-0   d-block font-weight-normal w-100">
                                    Disposition Notes (Solar)
                                </label>
                                <div class="mt-2 col-12 px-0">
                                    <mat-form-field class="w-100 sg-validation" appearance="none">
                                        <input matInput formControlName="dispositionNotes" readonly/>
                                    </mat-form-field>
                                </div>
                            </div>
                            
                        </div>
                        <div class="px-3 pt-2">
                            <mat-icon class="clear-icon cursor" *ngIf="!isRTAReadOnly"
                            (click)="onDeleteIconClick(i)">delete</mat-icon>
                            <mat-icon class="disabled-icon" *ngIf="isRTAReadOnly">delete</mat-icon>
                        </div>
                    <!-- </ng-container> -->
                </div>
                </ng-container>
                    <div class="row px-3 pt-2 pb-3">
                        <button mat-stroked-button class="mat-primary mat-stroked-button mr-3"
                                [ngClass]="isRTAReadOnly ? '' : 'sg-primary-stroked'"
                                type="button"
                                [disabled]="isRTAReadOnly"
                                (click)="onAddConditionClick()">Add Condition</button>
                    </div>
                    <div class="mat-dialog-title mb-0 cws-header">Attachments</div>
                    <div class="col-12 pl-0 pb-3" class="fileAttachmentContainer">
                        <div class="pb-2" *ngFor="let item of  linkList; let ind = index">
                            <span class="">
                                 <span>{{item.linkTitle}}</span>
                            </span>
                             <span class="material-icons-outlined pointer-cursor mat-primary pl-2"
                             [ngClass] = "!isRTAReadOnly ? 'pointer-cursor' : 'cursor-not-allowed'" 
                             (click)="!isRTAReadOnly ? removeLinkList(ind) : '' ">close</span> 
                         </div>
                    </div>
                    <div class="col-12 pl-0 pb-3 ppap-link" *ngIf="!isRTAReadOnly">
                        <input type="file" formControlName="filesUploadAttachment" id="filesUpload" (change)="onFileSelected($event)" style="display:none"/> 
                        <a (click)="fileUpload()" class="enable-icon underline sg-link-primary">Add Attachment</a>
                    </div>
                    <div class="col-12 pl-0 pb-3 ppap-link" *ngIf="isRTAReadOnly">
                        <input type="file" formControlName="filesUploadAttachment" id="filesUpload" (change)="onFileSelected($event)" style="display:none"/> 
                        <a (click)="fileUpload()" class="enable-icon underline disable-link cursor-not-allowed">Add Attachment</a>
                    </div>
                </div>
                <div class="row mx-0 pt-3" *ngIf="isRTAEditForm && generalRTAInformation.rtaStatus != 'Draft'">
                    <div class="mat-dialog-title w-100 mb-0 border-bottom  cws-header">Section 2 - RTA Disposition </div>
                    <div class="row w-100 pl-3 pr-3">
                        <div class="col-2 pt-3 pl-2 pr-0 offset-9">Solar Approval Effectivity</div>
                    </div>
                    <div class="row w-100 pl-3 pr-3">
                        <div class="col-3 p-0">
                
                            <div class="sg-form-field-label pt-3 pb-1">
                                Deviation Permit or Concession
                            </div>
                            <div>
                                {{rtaDisposition ? rtaDisposition.deviationPermit : '-'}}
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="sg-form-field-label pt-3 pb-1">
                                Change Request (if applicable)
                            </div>
                            <div>
                                {{rtaDisposition ? rtaDisposition.changeRequest : '-'}}
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="sg-form-field-label pt-3 pb-1">
                                Problem Report or ECR No. (if applicable)
                            </div>
                            <div>
                                {{rtaDisposition ? rtaDisposition.problemReportECRNo : '-'}}
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="row">
                                <div class="sg-form-field-label col-6 px-2 pt-3 pb-1">
                                    Total Quantity of Parts
                                </div>
                                <div class="sg-form-field-label col-6 px-2 pt-3 pb-1">
                                    Solar Approved Period
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6 px-2" style="word-wrap: break-word;">
                                    {{rtaDisposition ? rtaDisposition.totalQuantityOfParts : '-'}}
                                </div>
                                <div class="col-6 px-2" style="word-wrap: break-word;">
                                    {{rtaDisposition ? rtaDisposition.solarApprovedPeriod : '-'}}
                                </div>
                            </div>
                
                        </div>
                    </div>
                    <div class="row w-100 pl-3 pr-3 pb-5">
                        <div class="col-6 px-0">
                            <div class="sg-form-field-label pt-3 pb-1">
                                Part Identification Location & Method (per drawing unless instructed otherwise):
                            </div>
                            <div>
                                {{rtaDisposition ? rtaDisposition.partIdentificationLocationMethod : '-'}}
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="sg-form-field-label pt-3 pb-1">
                                Additional Solar Comments / Instructions / Conditions:
                            </div>
                            <div>
                                {{rtaDisposition ? rtaDisposition.additionalSolarComments : '-'}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </mat-drawer-container>
        </div>
        <div class="sg-footer-section w-100">
        <div class="col-12 px-5 pt-2 pb-5">
            <div class="mat-dialog-actions row mx-0 justify-content-end">
                <button mat-raised-button class="mat-primary rep-action-button rep-btn-margin mr-4"
                    type="button" [disabled]="isRTAEditForm ? !RTAForm.valid || !RTAForm.dirty : !RTAForm.valid"
                    (click)="onRtaFormSubmit()">Submit</button>
                <button mat-stroked-button class="sg-primary-stroked modal-button rep-neutral-button mr-3" *ngIf="(user?.roleId == 2 || user?.roleId == 12) && (!isRTAEditForm || generalRTAInformation.rtaStatus == 'Draft')"
                  type="button" matTooltip="Saves information as a draft. RTA will not be submitted for Solar review"
                    (click)="onRtaSaveDraftClick()">
                    Save Draft</button>  
                    <!-- !RTAForm.get('rtaRequestDetails').valid -->
                    <!-- ||
                    ((!RTAForm.get('rtaRequestDetails.fromDate').value) || (!RTAForm.get('rtaRequestDetails.toDate').value)) &&
                    !RTAForm.get('rtaRequestDetails.quantityOfNonconformingParts').value -->
                <button mat-stroked-button class="sg-primary-stroked modal-button rep-neutral-button mr-3"
                    type="button" (click)="onClickBackOrClose()">Close</button>
            </div>
        </div>
        </div>
    </form>
</div>

<div class="sg-spinner" style="z-index: 99999;" *ngIf="isLoadingData">
    <mat-spinner></mat-spinner>
</div>
